import { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Grid } from '@mui/material';
import { InvoicingSettings } from '../../../components/dashboard/invoicing';
import { useDispatch } from '../../../redux/store';
import CustomToolbar from '../../../components/dashboard/invoicing/CustomToolbar';
import { getFacilityInvoiceSettings } from '../../../redux/slices/invoicing';

export default function Settings() {
  const dispatch = useDispatch();
  const [activeRows, setActiveRows] = useState([]);

  const customToolbar = useCallback(() => {
    const isFiltered = (filter) => filter === 'settings';
    return <CustomToolbar isFiltered={isFiltered} activeRows={activeRows} />;
  }, [activeRows]);
  useEffect(() => {
    dispatch(getFacilityInvoiceSettings());
  }, []);

  return (
    <>
      <Helmet>
        <title>Invoicing | Platform Solutions</title>
      </Helmet>
      <Grid item xl={12}>
        <Grid container spacing={3} direction="row" justifyContent="flex-start" alignItems="flex-start">
          <InvoicingSettings CustomToolbar={customToolbar} setActiveRows={setActiveRows} />
        </Grid>
      </Grid>
    </>
  );
}
